module.exports = __webpack_public_path__ + "img/paarl-royals-logo-icon.1d9766b8.png";